import { NavLink, Navigate, Route, Routes } from 'react-router-dom'
import { useSession } from './store/session'
import { Login } from './pages/Login'
import { Tiles } from './pages/Tiles'
import { Spider } from './pages/Spider'

export default function App() {
  const session = useSession((s) => s.session)
  const setSession = useSession((s) => s.setSession)

  if (!session) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  const navCls = ({ isActive }: { isActive: boolean }) =>
    isActive
      ? 'rounded-md border border-[color:var(--accent-strong)] bg-white/10 px-2 py-1 text-white'
      : 'rounded-md border border-white/10 bg-white/5 px-2 py-1 text-ink-200 hover:bg-white/10'

  return (
    <div className="min-h-full">
      <header className="sticky top-0 z-30 flex flex-wrap items-center gap-2 border-b border-white/10 bg-ink-950/80 px-4 py-2 text-xs backdrop-blur">
        <span className="font-bold text-white">skypanel</span>
        <NavLink to="/tiles" className={navCls}>
          ▦ tiles
        </NavLink>
        <NavLink to="/spider" className={navCls}>
          🕸 spider
        </NavLink>
        <span className="ml-auto text-ink-300">@{session.handle}</span>
        <button
          type="button"
          onClick={() => setSession(null)}
          className="glass-button"
          title="sign out"
        >
          sign out
        </button>
      </header>
      <Routes>
        <Route path="/tiles" element={<Tiles />} />
        <Route path="/spider" element={<Spider />} />
        <Route path="*" element={<Navigate to="/tiles" replace />} />
      </Routes>
    </div>
  )
}
